module.exports = __webpack_public_path__ + "img/toilet.79f95421.png";